/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_Center_Left_LabelInputs */



/**
* | output |
* | --- |
* | "Center Left" |
*
* @param {Style_Guide_Manager_Position_Center_Left_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_center_left_label = /** @type {((inputs?: Style_Guide_Manager_Position_Center_Left_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_Center_Left_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Centre gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitte links")
	if (locale === "it") return /** @type {LocalizedString} */ ("Centro sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Центр слева")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro Izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("左中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中央左")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केंद्र बाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro Esquerdo")
	return /** @type {LocalizedString} */ ("Center Left")
});